const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'tableSimple',
		'table'
	],

	config: {
		isSortable: true,
		lazyloadStepSize: 25,
		// preventSortOfField: {},
		buttonContext: 'order',
		renderEmptyBeforReady: false,
		showHead: false,
		showInsertButton: false,
		showColorCodedRows: true,
		showAllBorders: false,
		showDelimiterBorders: true,
		showScrollBarAnyway: true,
		inline: true,
		maxNrOfExportElements: 500000,
		privilegeBase: 'ttgshop_orders',
		rowActionsProperties: {
			colWidth: '80px'
		},
		rowActions: {}
	},

	model: {
		resourceFilters: {
			order: [{
				fieldCode: 'orderID',
				direction: 'asc'
			}]
		}
	},

	methods: {

		dataDealer: function(){
			var self = this;
			if(!self.model.controller){
				self.closest('templates_ttgShop_orders_controller', function(controller){
					self.model.controller = controller
				});
			}

			if(self.model.controller && !self.config.usage){
				self.config.usage = self.model.controller.config.usage || '';
			}

			if(self.config.usage === 'selection' && !self.model.isInPicker){
				self.model.selectedRowIDs = utils.simpleCopy(self.getResourceRegisterContent('selectedRowIDs') || []);
				self.model.blackListedOrderIDs = utils.simpleCopy(self.getResourceRegisterContent('blackListedOrderIDs') || []);
			}
		},

		sanitizeEntity: function(refEntity){
			var self = this;
			if(self.config.usage === 'selection' && self.config.isSelectionSource){
				refEntity.selected = utils.indexOf(self.model.selectedRowIDs, refEntity.attributes[refEntity.primaryKey || 'id']) > -1;
			}
		},

		onResourceSanitized: function(){
			if(this.config.isSelectionTarget){
				// correct order of selected entities
				var entityList = this.model.entityList;
				var orderedEntityList = {};
				var orderedEntityListByIndex = [];
				var entityKey, rowIndex, rowID;
				for(rowIndex in this.model.selectedRowIDs || []){
					rowID = this.model.selectedRowIDs[rowIndex];
					entityKey = `entityID_${rowID}`;
					if(entityList[entityKey]){
						entityList[entityKey].index = rowIndex;
						orderedEntityList[entityKey] = entityList[entityKey];
						orderedEntityListByIndex[rowIndex] = entityList[entityKey];
					}
				}

				this.model.entityList = orderedEntityList;
				this.model.entityListByIndex = orderedEntityListByIndex;
			}
		},

		sanitizeResourceFilters: function(storage, resourceFilters, actionKey){
			if(actionKey === 'refreshResources'){
				var self = this;
				if(self.model.isInPicker === undefined){
					self.model.isInPicker = false;
					self.parent(function(parent){
						if(parent.hasClass('templates_ttgShop_orders_picker_button')){
							self.model.isInPicker = true;
							self.model.selectedRowIDs = parent.model.dataJSON || [];
						}
					});
				}

				if(self.model.selectedUserID === undefined){
					self.model.selectedUserID = 0;
					self.parent(function(parent) {
						if (parent.hasClass('templates_ttgShop_users_propertiesForm')) {
							var userID = (
								(((parent.resourceData.data || [])[0] || {}).attributes || {}).userID
								||
								(((parent.resourceData.data || [])[0] || {}).attributes || {}).id
								||
								((parent.resourceData.data || []).attributes || {}).userID
								||
								((parent.resourceData.data || []).attributes || {}).id
								||
								0
							);
							if(userID > 0){
								self.model.selectedUserID = userID
							}
						}
					})
				}

				resourceFilters = resourceFilters || {};
				resourceFilters.baseFilters = resourceFilters.baseFilters || {};

				if(this.config.isSelectionSource){
					if(utils.collectionSize(this.model.blackListedOrderIDs) > 0){
						resourceFilters.baseFilters.blackListedOrderIDs = this.model.blackListedOrderIDs;
					} else {
						resourceFilters.baseFilters.blackListedOrderIDs = [];
					}
				}

				if(this.config.isSelectionTarget){
					if(utils.collectionSize(this.model.selectedRowIDs) > 0){
						resourceFilters.baseFilters.listOfPrimaryKeys = this.model.selectedRowIDs;
					} else {
						resourceFilters.baseFilters.listOfPrimaryKeys = [];
					}
				}

				if(self.model.selectedUserID > 0){
					resourceFilters.baseFilters.userID = self.model.selectedUserID;
				}

				resourceFilters.filters = resourceFilters.filters || {};
			}
			return resourceFilters;
		},

		addEntity: function(entity){
			// add entity to dom if possible
			if(this.config.isReady && (this.model.$table || []).length > 0){
				this.model.$table.append(this.include('./row', { config: this.config, resourceData: entity, model: this.model }));
			}
		},

		showInsert: function(rowID, rowData, buttonMode){
			return this.performAndStoreAction(
				'showInsert_order_inEffect',
				this.prepareAction('showInsert_order', undefined, {
					componentDefinition: utils.simpleCopy((this.model.controller || {}).resourceData || {})
				}),
				true
			);
		},

		showEdit: function(rowID, rowData, buttonMode){
			if (rowID) {
				if(this.config.usage === 'selection'){
					if(this.config.isSelectionSource && this.model.controller){
						this.model.controller.toggleRowSelection(rowID, rowData);
					}
				} else {
					return getComponent('ttgShopController').showEdit('order', rowID);
				}
			}
		},

		delete: function(rowID, rowData, buttonMode){
			if(this.config.usage === 'selection' && this.config.isSelectionTarget){
				if(this.model.isInPicker){
					this.toggleRowSelection(rowID, rowData);
				} else if(this.model.controller){
					this.model.controller.toggleRowSelection(rowID, rowData);
				}
			}
		},

		selectionChanged: function(){
			if(this.model.isInPicker){
				this.triggerClosest('onChildChanged', {
					value: this.getSelectedRowIDs()
				});
			}
		},
	},

	hooks: {
		async onDecision($element, options){
			switch(options.decisionType){
				case 'submit':
					switch(options.decisionComponent.componentClass) {
						case 'base_modal_modal':
						case 'templates_modal_modal':
							const modalContentComponent = options.decisionComponent.actions.loadContent.source.load.component
							if(modalContentComponent && modalContentComponent.hasClass('templates_ttgShop_orders_propertiesForm')){
								await modalContentComponent.submit()
                                await options.decisionComponent.hide()
                                await this.refreshData()
							}
							break
					}
					break

				case 'cancel':
					switch(options.decisionComponent.componentClass) {
						case 'base_modal_modal':
						case 'templates_modal_modal':
							await options.decisionComponent.hide()
							break
					}
					break

				default:
					// TODO: ERROR;
					break
			}
		},

		toggleRowSelection: function($element, options){
			this.toggleRowSelection(options.rowID, options.rowData);
		}
	},

	handlers: [{
		name: 'onSubmitDone',
		componentClass: 'templates_ttgShop_orders_propertiesForm',
		handle: function(callerComponent, nodeData, insertPerformed){
			this.refreshData();
		}
	}]
}
